import { createContext } from 'react';
import { UCL } from '../types/UCL';

export const RemoteUclContext = createContext<UCL>({} as UCL);
